import React from 'react'
import { RatablesSortByTypes } from './Ratables'

export type RatablesSortProps = { handleClick: (sortType: string) => void }

export const RatablesSort = ({ handleClick }: RatablesSortProps) => (
  <>
    <div className="frw-heading--6">Sort by</div>
    <div className="frw-search__issues">
      <form className="frw-search__issues--form" name="issue__form">
        <div className="frw-search__issues--type">
          <input
            type="radio"
            id="mostRecent"
            name="sort"
            value="Most Recent"
            onChange={() => handleClick(RatablesSortByTypes.MOST_RECENT)}
          />
          <label htmlFor="mostRecent">Most Recent</label>
        </div>
        <div className="frw-search__issues--type">
          <input
            type="radio"
            id="debtType"
            name="sort"
            value="Debt Type / Sub-Type"
            onChange={() => handleClick(RatablesSortByTypes.DEBT_TYPE)}
          />
          <label htmlFor="debtType">Debt Type / Sub-Type</label>
        </div>
      </form>
    </div>
  </>
)
export default RatablesSort
